import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { withStyles } from '@mui/styles';

import { Typography } from '@mui/material';
import { StoreUtil, PhoneUtil } from 'doctivity-shared/utils';
import { withRouter } from 'utils';
import { DynamicTable } from 'components';
import { favoritesByType } from 'store/actions/favoritesActions';
import { ContactsTabs } from './ContactsTabs';

const styles = (theme) => ({
  title: {
    padding: theme.spacing(3),
    paddingBottom: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    backgroundColor: theme.palette.primary.accent,
  },
  headerTitle: {
    color: '#FFFFFF',
    fontSize: 24,
    paddingRight: 30,
  },
  container: {
    padding: theme.spacing(3),
  },
});

class FavoriteContactsPage extends React.Component {
  constructor(props) {
    super(props);

    this.columns = [
      {
        label: 'Last Name',
        key: 'last_name',
        fulltext: true,
        style: { minWidth: 70 },
      },
      {
        label: 'First Name',
        key: 'first_name',
        fulltext: true,
        style: { minWidth: 70 },
      },
      {
        label: 'Title',
        key: 'title',
        fulltext: true,
      },
      {
        label: 'Organization',
        key: 'location.organization.name',
        fulltext: true,
      },
      {
        label: 'Company',
        key: 'company',
        style: { minWidth: 100 },
      },
      {
        label: 'Phone Number',
        key: 'phone',
        format: (value) => PhoneUtil.formatNumber(value) || value,
        style: { minWidth: 100 },
      },
      {
        label: 'Owner',
        key: 'owner.last_name',
        format: (value, row) => {
          if (row.owner) {
            return `${row.owner.last_name}, ${row.owner.first_name}`;
          }
          return '';
        },
        style: { width: 80 },
      },
    ];

    this.state = {
      query: {
        where: {},
        order: [['last_name', 'ASC']],
        limit: 25,
        offset: 0,
      },
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.clientId !== prevProps.clientId ||
      this.props.userId !== prevProps.userId
    ) {
      this.fetchData();
    }
  }

  fetchData() {
    const { dispatch, clientId, userId } = this.props;
    const { where, order, limit, offset } = this.state.query;

    dispatch(favoritesByType(clientId, userId, 'Contacts', {
      where,
      order,
      limit,
      offset,
    }));
  }

  render() {
    const { classes } = this.props;

    const { query } = this.state;

    const favorites = this.props.favorites;

    let favoritesData;
    if (StoreUtil.isLoading(favorites)) {
      favoritesData = { placeholder: true, showLoading: true, showNoData: false };
    } else if (favorites.data) {
      favoritesData = {
        count: favorites.data.count,
        rows: favorites.data.rows
          .filter((row) => row.contact)
          .map((row) => row.contact),
      };
    } else {
      favoritesData = { placeholder: true, showNoData: false, showLoading: false };
    }

    return (
      <>
        <title>Contacts</title>
        <div className={classes.title}>
          <Typography className={classes.headerTitle}>Contacts</Typography>
        </div>
        <ContactsTabs tab='favorite_contacts' />
        <div className={classes.container}>
          <DynamicTable
            header='Favorite Contacts'
            showFilters={true}
            columns={this.columns}
            query={query}
            data={favoritesData}
            onQueryChange={this.onQueryChange}
            getRowHref={(row) => `/contacts/${row.id}`}
          />
        </div>
      </>
    );
  }

  onQueryChange = (query) => {
    if (query.where && Object.keys(query.where).length === 0) {
      delete query.where;
    }
    this.setState({ query }, this.fetchData.bind(this));
  };
}

FavoriteContactsPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  clientId: PropTypes.number.isRequired,
  favorites: PropTypes.object.isRequired,
  userId: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
  const { favorites } = state;
  const userId = state.user ? state.user.id : null;
  const clientId = state.app.selectedClient;

  return {
    userId,
    clientId,
    favorites: StoreUtil.get(favorites, 'by_type', `${clientId}-${userId}-Contacts`),
  };
}

const styled = withStyles(styles)(FavoriteContactsPage);
const connected = connect(mapStateToProps)(styled);
const routed = withRouter(connected);
export { routed as FavoriteContactsPage };
